module.exports = __webpack_public_path__ + "static/media/notosans-light.da834ccc.ttf";